import { Injectable, inject } from '@angular/core';
import {NetworkService} from '../../../../../../projects/common/src/lib/services/network.service';
import {BaseApiService} from '../base-api.service';
import {FirebaseApi} from '../../firebase-api.service';
import {Logger} from '../../../utils/logger';
import {ProjectComment} from '../../../model/project-comment';
import {AuthService} from '../../auth.service';


@Injectable({
  providedIn: 'root',
})
export class UserApiService extends BaseApiService {

  constructor() {

    super();
  }

  createNewUser(data: {fullName: string, company?: string}) {
    return this.post(`/account/new`, data);
  }
}
